import React from 'react'
import { contentTypesForTags } from '../Data/StaticData'

function MoreInputs(props) {
  const {
    enteredValue,
    // handleContentTypeChange,
    // handleTypeChange,
    selectedTab,
    handleFilterChangeForTabs,
    handleTagTypeChange,
  } = props
  return (
    <div>
      {' '}
      {/* {props.serviceType === 'editTag' ? null : (
        <div className='d-flex gap-2 align-items-center'>
          <label className='labelWidth d-flex gap-2'>
            mode:
            <input
              type='radio'
              name='type'
              value='TFIDB'
              checked={enteredValue.mode === 'TFIDB'}
              onChange={handleTypeChange}
            />
            TFIDB
          </label>
          <label className='labelWidth d-flex gap-2'>
            <input
              type='radio'
              name='type'
              value='Admin'
              checked={enteredValue.mode === 'Admin'}
              onChange={handleTypeChange}
            />
            Admin
          </label>
        </div>
      )} */}
      {/* {props.serviceType === 'editTag' ? null : (
        <div className='d-flex gap-3'>
          <label className='labelWidth'>Content Type:</label>
          <label className='flex gap-1 mr-1'>
            <input
              type='radio'
              name='contentType'
              value='person'
              checked={enteredValue.contentType === 'person'}
              onChange={handleContentTypeChange}
            />
            Person
          </label>
          <label className='flex gap-1'>
            <input
              type='radio'
              name='contentType'
              value='movies'
              checked={enteredValue.contentType === 'movies'}
              onChange={handleContentTypeChange}
            />
            Movie
          </label>
          {enteredValue.mode === 'TFIDB' && (
            <>
              {' '}
              <label className='flex gap-1'>
                <input
                  type='radio'
                  name='contentType'
                  value='personGalleryImages'
                  checked={enteredValue.contentType === 'personGalleryImages'}
                  onChange={handleContentTypeChange}
                />
                Person Gallery Images
              </label>
              <label className='flex gap-1'>
                <input
                  type='radio'
                  name='contentType'
                  value='personGalleryVideos'
                  checked={enteredValue.contentType === 'personGalleryVideos'}
                  onChange={handleContentTypeChange}
                />
                Person Gallery Videos
              </label>
            </>
          )}
        </div>
      )} */}
      {props.serviceType === 'editTag' ? null : (
        <div className='d-flex mt-4 flex-wrap'>
          {contentTypesForTags.map((item, index) => (
            <div
              name='TypeWithGoodBad'
              style={{ cursor: 'pointer' }}
              className={`border border-black px-2 py-1 ${
                item.name === selectedTab ? 'bg-blue' : ''
              }`}
              value={item}
              onClick={() => handleFilterChangeForTabs(item)}
              key={index}
            >
              {item.name}
            </div>
          ))}
        </div>
      )}
      {props.serviceType === 'editTag' ? null : (
        <>
          {enteredValue.mode === 'Admin' && (
            <div className='d-flex gap-4'>
              <label className='labelWidth'>Tag Type:</label>
              <label className='flex gap-1'>
                <input
                  type='radio'
                  name='tagType'
                  value='good'
                  checked={enteredValue.tagType === 'good'}
                  onChange={handleTagTypeChange}
                />
                <span>Good</span>
              </label>
              <label className='flex gap-1'>
                <input
                  type='radio'
                  name='tagType'
                  value='bad'
                  checked={enteredValue.tagType === 'bad'}
                  onChange={handleTagTypeChange}
                />
                <span>Bad</span>
              </label>
              {/* {errors.tagType && <span className='error'>{errors.tagType}</span>} */}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default MoreInputs
